const blue = '#0af';
export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Roboto+Condensed',
  fonts: {
    body: '"Roboto Condensed", system-ui, sans-serif',
    monospace: '"Roboto Mono", monospace'
  },
  colors: {
    text: '#fff',
    background: '#000',
    primary: blue,
    pre: blue,
    darkgray: '#111'
  },
  fontWeights: {
    heading: 600,
    bold: 600
  },
  text: {
    heading: {
      textTransform: 'uppercase'
    }
  },
  styles: {
    pre: {
      color: 'primary',
      bg: 'darkgray'
    },
    code: {
      color: 'primary'
    }
  }
};